import _ from "lodash";
import { VueSlideToggle } from "vue-slide-toggle";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { formatPrice, isPaymentNotRequired, resolveProductImage, routeToProduct } from "@/helpers";

const DeliveryType = {
  PICKUP: "pickup",
  STORAGE: "storage",
  ADDRESS: "address",
  COURIER: "courier",
};
export default {
  name: "order-item",
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    showPayment: {
      type: Boolean,
      default: () => false,
    },
    professional: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      open: false,
      loadingArray: [],
    };
  },
  components: {
    VueSlideToggle,
  },
  computed: {
    ...mapGetters({
      repeatProducts: "order/repeatProducts",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
      user: "profile/user",
    }),
    onlyWebinarsOrTickets() {
      return this.order.orderProducts.data.every(p => (p.product.data.type === "webinar" || p.product.data.type === "ticket"))
    }
  },
  created() {
    if (this.$route.query.order) {
      if (this.order.id == this.$route.query.order) {
        this.open = true;
        this.$nextTick(() => {
          let scrollOptions = {
            behavior: "smooth",
            block: "center",
            inline: "center",
          };

          this.$el.scrollIntoView(scrollOptions);
        });
      }
    }
  },
  methods: {
    formatPrice,
    resolveProductImage,
    routeToProduct,
    ...mapActions({
      repeatOrder: `order/REPEAT_ORDER`,
      repeatTransaction: `order/REPEAT_TRANSACTION`,
      getWebinarsById: "cosmobase/GET_WEBINARS_BY_ID"
    }),
    ...mapMutations({
      resetBasket: `basket/RESET_BASKET`,
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
    }),
    /**
     * @param {DeliveryMethod} delivery
     * @return {string|null}
     */
    async navigateToProduct(data) {
      const webinarID = data.webinar.data.id;
      if (data.webinar) {
        try {
          await this.getWebinarsById(webinarID);
          this.$router.push({
            name: "cosmobase-course",
            params: {
              id: webinarID
            }
          })
        } catch (e) {
          console.log(e);
        }
      }
    },
    getTitleForDeliveryInList(delivery) {
      if (!delivery) {
        return null;
      }

      if (delivery.type === DeliveryType.PICKUP) return this.$t("free");
      if (delivery.type === DeliveryType.STORAGE) return this.$t("deliveries.accordingToTheCarrierTariffs");
      if (delivery.type === DeliveryType.ADDRESS) return this.$t("deliveries.accordingToTheCarrierTariffs");
      if (delivery.type === DeliveryType.COURIER) return formatPrice(delivery.price) + " " + this.$t("grn");

      if (delivery.price <= 0) return "";

      return delivery.price + " " + this.$t("grn");
    },
    copyToClipboard(value) {
      const textarea = document.createElement("textarea");
      textarea.value = value;

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999);

      try {
        document.execCommand("copy");
        console.log("Copied to clipboard: ", value);
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
      this.$toasted.success("Номер TTH успішно скопійовано");
      document.body.removeChild(textarea);
    },
    async repeat(id) {
      this.loadingArray.push(id);
      const response = await this.repeatTransaction(id);
      if (isPaymentNotRequired(response.data)) {
        this.$toasted.success(this.$t("successCreateOrder"));
        this.loadingArray.splice(this.loadingArray.indexOf(id), 1);
        return;
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(response.data, 'text/html');
      const form = doc.getElementById('checkout-form');
      if (!form) {
        console.error('Form not found in the response.');
        this.loadingArray.splice(this.loadingArray.indexOf(id), 1);
        return;
      }
      document.body.appendChild(form);
      form.submit();
      if (this.loadingArray.includes(id)) {
        this.loadingArray.splice(this.loadingArray.indexOf(id), 1);
      }
    },
    isLoading(id){
      return this.loadingArray.indexOf(id) !== -1;
    }
  },
};
